<script>
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import Modal from '@/components/atoms/Modal'
import Badge from '@/components/molecules/Badge'
import MethodBlock from '@/components/organism/checkout/MethodBlock'
import Box from '@/components/atoms/Box'
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import ExpenseRuleBlock from '@/components/organism/checkout/ExpenseRuleBlock'
import ModalCoupon from '@/components/organism/checkout/ModalCoupon'
import CanteenPayment from '@/components/organism/checkout/CanteenPayment'
import { mapGetters } from 'vuex'
import ModalConfirm from '@/components/organism/modal/ModalConfirm.vue'
import CardsBlock from '@/components/organism/checkout/CardsBlock.vue'
import FormValidation from '@/components/atoms/FormValidation.vue'
import PaymentBlocks from '@/components/organism/checkout/PaymentBlocks.vue'

export default {
    name: 'CheckoutPayment',
    components: {
        PaymentBlocks,
        FormValidation,
        CardsBlock,
        ModalConfirm,
        CanteenPayment,
        ModalCoupon,
        ExpenseRuleBlock,
        InputCheckbox,
        Box,
        MethodBlock,
        Badge,
        Modal,
        InputLine,
    },
    props: {
        stripe: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            needInvoice: false,
        }
    },
    computed: {
        ...mapGetters({
            requestInvoiceAvailable: 'site/requestInvoiceAvailable',
        }),
        cart() {
            return this.$cart || {}
        },
        calculation() {
            return this.$cart?.calculation || {}
        },
        requestInvoiceVisible() {
            return (
                this.requestInvoiceAvailable &&
                (!this.cart.selected_expense_rule || this.calculation.price_sum_user > 0)
            )
        },
        residentialCanteen() {
            return this.cart.calculation.residentialcanteen
        },
    },
    watch: {
        'cart.payment_method': {
            handler(method) {
                if (
                    method === this.$cardPayment &&
                    !this.cart.selected_expense_rule &&
                    this.requestInvoiceVisible &&
                    this.$user.model?.last_billing_info?.name
                ) {
                    this.$cart.setInvoice(this.$user.model)
                    this.needInvoice = true
                    this.validateInvoiceInfo()
                }
            },
        },
    },
    methods: {
        setInvoice(val) {
            this.$cart.setInvoice(val ? this.$user.model : undefined)
            this.validateInvoiceInfo()
        },
        validateInvoiceInfo() {
            this.$emit(
                'input',
                !!(
                    (this.needInvoice &&
                        this.cart.billing_name &&
                        this.cart.billing_full_address) ||
                    !this.needInvoice
                )
            )
        },
    },
}
</script>

<template lang="pug">
.card.checkout-payment
    .card-body
        h2
            template(v-if="cart.isCloudCanteen") {{$t('cart.payment_method_cc')}}
            template(v-else) {{$t('cart.payment_method')}}

        h3.mr-2.text-break(v-if="residentialCanteen") {{ residentialCanteen.name }}
        canteen-payment.mb-6(v-if="cart.isCloudCanteen" :stripe="stripe")
        payment-blocks(:stripe="stripe" v-else)
        .d-flex.align-items-center.flex-wrap.border-top
            input-checkbox.mt-6(v-if="requestInvoiceVisible" v-model="needInvoice" @input="setInvoice" :readonly="cart.loading") {{ $t('cart.invoice') }}
            modal-coupon.mt-6.ml-auto
        box(v-if="requestInvoiceVisible" v-model="needInvoice" id="invoice_info" slim)
            form-validation
                input-line.pt-5(
                    v-model="$cart.model.billing_name"
                    @input="validateInvoiceInfo"
                    :readonly="cart.loading"
                    validate="billingName"
                    :placeholder="$t('labels.placeholder.billing_name')"
                    :max="255"
                    live required) {{$t('details.name')}}
                input-line.pt-5(
                    v-model="$cart.model.billing_vatnumber"
                    @input="validateInvoiceInfo"
                    :disabled="cart.loading"
                    validate="billingVatnumber"
                    regex="^[0-9]{8}-[0-9]{1}-[0-9]{2}$"
                    :placeholder="$t('labels.placeholder.billing_vatnumber')"
                    :max="255"
                    live required) {{$t('details.vat')}}
                input-line(
                    v-model="$cart.model.billing_full_address"
                    @input="validateInvoiceInfo"
                    :readonly="cart.loading"
                    validate="billingFullAddress"
                    :placeholder="$t('labels.placeholder.billing_full_address')"
                    :max="255"
                    live required) {{$t('details.address')}}
                input-line(
                    v-model="$cart.model.billing_sub_address"
                    @input="validateInvoiceInfo"
                    :readonly="cart.loading"
                    validate="billingSubAddress"
                    :placeholder="$t('labels.placeholder.billing_sub_address')"
                    :max="255"
                    live)



</template>
